import { commonMenuItems } from "./common";
import defaultProfile from "./default";
import type { ConfigSection, GameProfile, Menu, ProfileCtx } from "./types";

const configSections: ConfigSection[] = [
  { component: "ConfSection", props: { name: "branch" } },
  { component: "ConfSection", props: { name: "basic" } },
  { component: "ConfSection", props: { name: "Player settings" } },
  // World section: "Create a new world" button (header) opens a modal carrying the create-time
  // world-gen settings; the section body holds the world (save) selector. Mirrors Factorio.
  { component: "VintageStoryWorldSettings", props: { name: "World" } },
];

const createMenu = (): Menu => {
  const menu = defaultProfile().menu;
  menu[0].items.push(commonMenuItems.logs, commonMenuItems.console);
  return menu;
};

export default (_ctx: ProfileCtx): Partial<GameProfile> => ({
  menu: createMenu(),
  configSections,
});
